export const BASE_STOREFRONT_ENDPOINT = `${process.env.NEXT_PUBLIC_API_HOST}/storefront`
export const storeEndpoint = `${BASE_STOREFRONT_ENDPOINT}/store`
